import * as React from 'react';
import { ButtonPrimary } from '../../button';
import styles from './footer.scss';

export interface FooterProps {
  onClose: () => void;
  onConfirm?: () => void;
  textDone?: string;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const Footer: React.FC<FooterProps> = ({ onClose, onConfirm, textDone, disabled, children }) => {
  return (
    <div className={styles.expanderFooter}>
      {children}
      <ButtonPrimary onClick={onConfirm ? onConfirm : onClose} disabled={disabled}>{textDone}</ButtonPrimary>
    </div>
  );
};
